export default {
  USD: '$',
  GBP: '£',
  ARS: 'ARS',
  AUD: 'A$',
  BRL: 'R$',
  CAD: 'CA$',
  CNY: 'CN¥',
  CZK: 'CZK',
  DKK: 'DKK',
  EUR: '€',
  HKD: 'HK$',
  HUF: 'HUF',
  INR: '₹',
  ILS: '₪',
  JPY: '¥',
  MXN: 'MX$',
  TWD: 'NT$',
  NZD: 'NZ$',
  NOK: 'NOK',
  PLN: 'PLN',
  RUB: 'RUB',
  SGD: 'SGD',
  ZAR: 'ZAR',
  KRW: '₩',
  SEK: 'SEK',
  CHF: 'CHF',
  THB: 'THB',
  TRY: 'TRY',
  UAH: 'UAH',
}
